<template>
  <div class="ccm">
    <div class="ccm-box">
		<div class="ccm-items">
			<div class="ccm-item ccm-chat" title="聊天列表" :class="{'ccm-chat-active': currentActiveItem == 'chat'}" @click="changeItem('chat')">
				<span v-if="count > 0">{{count | pass99}}</span>
			</div>
			<div class="ccm-item ccm-friend" title="好友通讯录" :class="{'ccm-friend-active': currentActiveItem == 'fans'}" @click="changeItem('fans')">
				
			</div>
			<div class="ccm-item ccm-cluster" title="群列表" :class="{'ccm-cluster-active': currentActiveItem == 'cluster'}" @click="changeItem('cluster')">
				
			</div>
			<div class="ccm-item ccm-custom" title="客服列表" :class="{'ccm-custom-active': currentActiveItem == 'custom'}" @click="changeItem('custom')">
				
			</div>
			<div class="ccm-item ccm-helper" title="群发助手" :class="{'ccm-helper-active': currentActiveItem == 'helper'}" @click="changeItem('helper')" v-if="helperShow">
				
			</div>
		</div>
	</div>
	<div class="ccm-setting" title="设置" @click="changeItem('setting')">
		
	</div>
  </div>
</template>

<script>
import {getRecentlyNoReadAll} from '../network/local/recently.js'
import {getLocalConfig} from '../functions/Common.js'

export default {
  name: 'ChatMenu',
  data(){
	  return {
		  currentActiveItem: 'chat',
		  count: 0,
		  helperShow: true
	  }
  },
  methods:{
	  // 列表点击切换
	  changeItem(value){
		  this.currentActiveItem = value
		  let url = '/chat/'+value
		  if(url != this.$route.path){
			  this.$router.push(url)
		  }
	  },
	  
	  // 根据路由自动选择当前tab
	  autoChooseTab(){
		  let path = this.$route.path
		  let urls = path.split('/')
		  this.currentActiveItem = urls[urls.length - 1]
	  },
	  
	  // 重新加载未读数据
	  reloadCount(){
		  getRecentlyNoReadAll(count=>{
			  this.count = count
		  }) 
	  },
	  
	  // 群发助手显隐判断
	  getHelplerShow(){
		  let msgHelperPlug = getLocalConfig('msgHelperPlug')
		  if(msgHelperPlug != 1){
		  	this.helperShow = false
		  }	
	  }
  },
  created() {
	  this.autoChooseTab()
	  this.reloadCount()
	  this.getHelplerShow()
  },
  activated() {
  	this.autoChooseTab()
  },
  watch:{
	  $route(to, from) {
		  if(to.path === '/chat/chat'){
			  this.currentActiveItem = 'chat'
		  }
	  }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.ccm{
		position: relative;
		width: 80px;
		height: 100%;
		background-color: #27354a;
	}
	.ccm .ccm-box{
		width: 80px;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 80px;
	}
	.ccm-box .ccm-items{
		width: 80px;
		height: 100%;
		overflow: hidden;
	}
	.ccm-items .ccm-item{
		width: 80px;
		height: 80px;
		background-size: 28px auto;
		background-position: center;
		background-repeat: no-repeat;
		cursor: pointer;
		position: relative;
	}
	.ccm-items .ccm-chat{
		background-image: url(../assets/img/comp-chat.png);
	}
	.ccm-items .ccm-friend{
		background-image: url(../assets/img/comp-friend.png);
	}
	.ccm-items .ccm-cluster{
		background-image: url(../assets/img/comp-cluster.png);
	}
	.ccm-items .ccm-custom{
		background-image: url(../assets/img/comp-custom.png);
	}
	.ccm-items .ccm-helper{
		background-image: url(../assets/img/comp-helper.png);
	}
	.ccm-items .ccm-chat-active{
		background-image: url(../assets/img/comp-chat-active.png) !important;
	}
	.ccm-items .ccm-friend-active{
		background-image: url(../assets/img/comp-friend-active.png) !important;
	}
	.ccm-items .ccm-cluster-active{
		background-image: url(../assets/img/comp-cluster-active.png) !important;
	}
	.ccm-items .ccm-custom-active{
		background-image: url(../assets/img/comp-custom-active.png) !important;
	}
	.ccm-items .ccm-helper-active{
		background-image: url(../assets/img/comp-helper-active.png) !important;
	}
	.ccm .ccm-setting{
		width: 80px;
		height: 80px;
		position: absolute;
		left: 0;
		bottom: 0;
		background-size: 28px auto;
		background-position: center;
		background-repeat: no-repeat;
		cursor: pointer;
		background-image: url(../assets/img/comp-setting.png);
	}
	.ccm .ccm-setting:hover{
		background-image: url(../assets/img/comp-setting-active.png) !important;
	}
	.ccm-item span{
		position: absolute;
		top: 20px;
		right: 20px;
		padding: 0 3px;
		height: 16px;
		line-height: 16px;
		border-radius: 50%;
		text-align: center;
		background-color: #f14b13;
		color: #FFFFFF;
		font-size: 12px;
		min-width: 10px;
	}
</style>
